import {autoinject} from 'aurelia-framework';
import { PipelineStep, NavigationInstruction, Next } from 'aurelia-router';
import { AureliaRouteContextManager  } from '../../otel/route-context-manager';
import { AureliaBatchSpanProcessor } from '../../otel/batch-span-processor';

@autoinject()
export class AureliaContextPipelineStep implements PipelineStep {
    constructor(private readonly contextManager: AureliaRouteContextManager,private absp : AureliaBatchSpanProcessor ) {
    }
    run(instruction: NavigationInstruction, next: Next): Promise<any> {
        this.absp.forceFlush();
        this.contextManager.UpdateContext( { instruction: instruction });

        return next();
    }
}
